"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryFunctions_1 = require("../queryFunctions");
function isSerializableResponseWithData(response) {
    return "response" in response && "data" in response;
}
function defaultMergePages(existing, next) {
    if (isSerializableResponseWithData(existing) &&
        isSerializableResponseWithData(next)) {
        if (queryFunctions_1.hasItemsArray(existing.data) && queryFunctions_1.hasItemsArray(next.data)) {
            var _a = existing.data, existingItems = _a.items, existingRest = __rest(_a, ["items"]);
            var _b = next.data, nextItems = _b.items, nextRest = __rest(_b, ["items"]);
            return {
                response: next.response,
                data: __assign(__assign({ items: existingItems.concat(nextItems) }, existingRest), nextRest),
            };
        }
        if (Array.isArray(existing.data) && Array.isArray(next.data)) {
            return {
                response: next.response,
                data: existing.data.concat(next.data),
            };
        }
    }
    console.error("Unable to merge data pages");
    return next;
}
exports.default = defaultMergePages;
//# sourceMappingURL=defaultMergePages.js.map